/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferOrderSearchFilterSortOrder = 'ByCompanyNumberASC' | 'ByCreatedAtASC' | 'ByOfferOrderNumberASC' | 'ByOfferOrderStatusASC' | 'ByProductTypeASC' | 'ByPublishDateASC' | 'ByTopJobASC' | 'ByJobBlitzASC' | 'ByKalaydoASC' | 'ByItJobsASC' | 'ByItJobsDESC' | 'ByKalaydoDESC' | 'ByJobBlitzDESC' | 'ByTopJobDESC' | 'ByPublishDateDESC' | 'ByProductTypeDESC' | 'ByOfferOrderStatusDESC' | 'ByOfferOrderNumberDESC' | 'ByCreatedAtDESC' | 'ByCompanyNumberDESC';

export const OfferOrderSearchFilterSortOrder = {
    ByCompanyNumberASC: 'ByCompanyNumberASC' as OfferOrderSearchFilterSortOrder,
    ByCreatedAtASC: 'ByCreatedAtASC' as OfferOrderSearchFilterSortOrder,
    ByOfferOrderNumberASC: 'ByOfferOrderNumberASC' as OfferOrderSearchFilterSortOrder,
    ByOfferOrderStatusASC: 'ByOfferOrderStatusASC' as OfferOrderSearchFilterSortOrder,
    ByProductTypeASC: 'ByProductTypeASC' as OfferOrderSearchFilterSortOrder,
    ByPublishDateASC: 'ByPublishDateASC' as OfferOrderSearchFilterSortOrder,
    ByTopJobASC: 'ByTopJobASC' as OfferOrderSearchFilterSortOrder,
    ByJobBlitzASC: 'ByJobBlitzASC' as OfferOrderSearchFilterSortOrder,
    ByKalaydoASC: 'ByKalaydoASC' as OfferOrderSearchFilterSortOrder,
    ByItJobsASC: 'ByItJobsASC' as OfferOrderSearchFilterSortOrder,
    ByItJobsDESC: 'ByItJobsDESC' as OfferOrderSearchFilterSortOrder,
    ByKalaydoDESC: 'ByKalaydoDESC' as OfferOrderSearchFilterSortOrder,
    ByJobBlitzDESC: 'ByJobBlitzDESC' as OfferOrderSearchFilterSortOrder,
    ByTopJobDESC: 'ByTopJobDESC' as OfferOrderSearchFilterSortOrder,
    ByPublishDateDESC: 'ByPublishDateDESC' as OfferOrderSearchFilterSortOrder,
    ByProductTypeDESC: 'ByProductTypeDESC' as OfferOrderSearchFilterSortOrder,
    ByOfferOrderStatusDESC: 'ByOfferOrderStatusDESC' as OfferOrderSearchFilterSortOrder,
    ByOfferOrderNumberDESC: 'ByOfferOrderNumberDESC' as OfferOrderSearchFilterSortOrder,
    ByCreatedAtDESC: 'ByCreatedAtDESC' as OfferOrderSearchFilterSortOrder,
    ByCompanyNumberDESC: 'ByCompanyNumberDESC' as OfferOrderSearchFilterSortOrder
};

